import { Container } from "@/shared/components/layout/Container";
import { Section } from "@/shared/components/layout/Section";
import { useMe } from "@/shared/lib/auth";
import { ChangeEmailForm } from "./ChangeEmailForm";
import { ChangePasswordForm } from "./ChangePasswordForm";
import { DeleteAccountDialog } from "./DeleteAccountDialog";
import { ProfileNameForm } from "./ProfileNameForm";

export function ProfilePage() {
  const me = useMe();

  return (
    <Section spacing="md">
      <Container size="2xl">
        <div className="flex flex-col gap-8">
          <h1 className="type-heading-lg text-text">Profile</h1>

          {me.isLoading ? (
            <p className="type-body-base text-text-muted">Loading…</p>
          ) : !me.data ? (
            <p className="type-body-base text-text-muted">
              Couldn't load your account.
            </p>
          ) : (
            <>
              <section className="glass-surface rounded-2xl p-6 flex flex-col gap-6">
                <div className="flex flex-col gap-1">
                  <h2 className="type-heading-sm text-text">Name</h2>
                  <p className="type-body-sm text-text-muted">
                    Update the name shown on your account.
                  </p>
                </div>
                <ProfileNameForm user={me.data} />
              </section>

              <section className="glass-surface rounded-2xl p-6 flex flex-col gap-6">
                <div className="flex flex-col gap-1">
                  <h2 className="type-heading-sm text-text">Email</h2>
                  <p className="type-body-sm text-text-muted">
                    Changing your email requires your current password and signs
                    out other devices.
                  </p>
                </div>
                <ChangeEmailForm user={me.data} />
              </section>

              <section className="glass-surface rounded-2xl p-6 flex flex-col gap-6">
                <div className="flex flex-col gap-1">
                  <h2 className="type-heading-sm text-text">Password</h2>
                  <p className="type-body-sm text-text-muted">
                    Changing your password requires your current password and
                    signs out other devices.
                  </p>
                </div>
                <ChangePasswordForm />
              </section>

              <section className="glass-surface rounded-2xl p-6 flex flex-col gap-4">
                <div className="flex flex-col gap-1">
                  <h2 className="type-heading-sm text-text">Delete account</h2>
                  <p className="type-body-sm text-text-muted">
                    Permanently delete your account and all associated data. This
                    cannot be undone.
                  </p>
                </div>
                <div>
                  <DeleteAccountDialog />
                </div>
              </section>
            </>
          )}
        </div>
      </Container>
    </Section>
  );
}
